import Vue from 'vue'
import { format } from 'date-fns'

Vue.filter('date', (payload) => {
  return format(payload, 'DD/MM/YYYY [às] HH:mm')
})

Vue.filter('hourDate', (payload) => {
  return format(payload, 'HH[h]mm [de] DD/MM/YYYY')
})

Vue.filter('dateWithoutHours', (payload) => {
  return format(payload, 'DD/MM/YYYY')
})
